import { render, staticRenderFns } from "./ContactDetailsAvatar.vue?vue&type=template&id=d9d3a6a2&scoped=true&"
import script from "./ContactDetailsAvatar.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsAvatar.vue?vue&type=style&index=0&id=d9d3a6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d3a6a2",
  null
  
)

export default component.exports